var _defs, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 183 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00a8c0;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 91.5,
    cy: 90,
    rx: 91.5,
    ry: 90
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.72,141.85l-10.09,6.66c-6.49,4.47-34.16,9.5-71.81-36.11-36.3-43.91-25.92-68.26-21-73.88l8.38-8.7a4.67,4.67,0,0,1,6.65.55l22,26.06h0a4.7,4.7,0,0,1-.56,6.67v0l-9.76,7.05C64.65,74,68,80,72,85.87l18.79,22.18c8.74,8.44,13.53,12.33,17.71,9.55l8.12-9.06a4.72,4.72,0,0,1,6.66.55l22,26.06v0A4.74,4.74,0,0,1,144.72,141.85Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon9);
export default __webpack_public_path__ + "static/media/icon9.37f54e7b5f0ec1da9440efe461efbd36.svg";
export { ForwardRef as ReactComponent };